import type { RouteObject } from 'react-router-dom';

import PumsemLayout from '@/app/layouts/PumsemLayout/PumsemLayout';
import PumsemManageLayout from '@/app/layouts/PumsemLayout/PumsemManageLayout';
import { AuthGuard, RoleGuard } from '@/app/router/guards';
import { lazyRoute } from '@/app/router/helpers';
import { ROUTES } from '@/shared/constants/app/routes.constant.ts';

/**
 * `/pumsem/*` — 품셈해설. 열람은 **전부 공개**, `/pumsem/manage/*` 만 ADMIN 이상이다.
 *
 * 열람에 로그인을 걸면 색인이 죽고, 국내 대체재(회원제 e-book)와 같은 진입장벽이
 * 생긴다. 로그인이 필요해지는 지점은 관리·내보내기이지 열람이 아니다.
 *
 * ── 레이아웃이 둘로 갈린다 ──────────────────────────────────
 *   `/pumsem`, `/pumsem/:division/:code[/diff]` → PumsemLayout (검색 셸)
 *   `/pumsem/manage/*`                          → PumsemManageLayout (전체 폭)
 *
 * 관리 화면을 검색 셸 밖에 두는 이유: 좌측 결과 목록이 편집 폼의 폭을 잡아먹고,
 * 관리자는 검색이 아니라 트리로 항목을 찾는다. 다만 **헤더·푸터는 품셈해설의
 * 것**이다 — 마케팅 레이아웃을 쓰면 관리 중에 다른 사이트로 넘어온 것처럼 보인다.
 *
 * 검색 조건은 URL 쿼리(`?q=` 등)에 있고 판 고정은 `?edition=` 이다
 * (경로가 아니다 — 현행 주소와 고정 주소를 갈라야 한다).
 *
 * `manage` 는 `:division` 보다 먼저 선언한다 — React Router 는 선언 순서와
 * 무관하게 정적 세그먼트를 우선 매칭하지만, 읽는 사람이 우선순위를 오해한다.
 */
export const pumsemRoutes: RouteObject[] = [
  {
    path: ROUTES.PUMSEM,
    Component: PumsemManageLayout,
    children: [
      {
        element: <AuthGuard />,
        children: [
          {
            element: <RoleGuard allowedRoles={['ADMIN', 'SUPER_ADMIN']} />,
            children: [
              {
                path: ROUTES.PUMSEM_MANAGE_NEW,
                ...lazyRoute(
                  () => import('@/pages/pumsem/manage/PumsemItemFormPage'),
                ),
              },
              {
                path: ROUTES.PUMSEM_MANAGE_EDIT,
                ...lazyRoute(
                  () => import('@/pages/pumsem/manage/PumsemItemFormPage'),
                ),
              },
              {
                path: ROUTES.PUMSEM_MANAGE,
                ...lazyRoute(
                  () => import('@/pages/pumsem/manage/PumsemManagePage'),
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: ROUTES.PUMSEM,
    Component: PumsemLayout,
    children: [
      {
        index: true,
        ...lazyRoute(() => import('@/pages/pumsem/PumsemIndexPage')),
      },
      {
        path: ROUTES.PUMSEM_DIFF,
        ...lazyRoute(() => import('@/pages/pumsem/PumsemDiffPage')),
      },
      {
        path: ROUTES.PUMSEM_ITEM,
        ...lazyRoute(() => import('@/pages/pumsem/PumsemItemPage')),
      },
    ],
  },
];
